<template>
    <div>
        <component-loader
            :key="$i18n.locale"
            v-if="componentInitialized"
            :component-name="componentName"
            :default-component-name="defaultComponentName"
            id="monitoring-component"
        >
        </component-loader>
        <div class="clearance-box mt-5 row">
            <div class="col-12 pl-0 pr-0">
                <div class="clearance-bar">
                    <label>{{ $t('monitoring.title_clearance_box') }}</label>
                    <radio name="report.clearance"
                        class="form-check-inline"
                        value="cleared-with-condition"
                        v-model="MonitoringForm.report.clearance"
                        :disabled="(loggedUser.role !== UserRoles.ADMIN && loggedUser.role !== UserRoles.REGIONAL_ADMIN) || !MonitoringForm.isEditable"
                        >
                        <label>{{ $t('monitoring.field_title_cleared_under_conditions') }}</label>
                    </radio>
                    <radio name="report.clearance"
                        class="form-check-inline"
                        value="cleared"
                        v-model="MonitoringForm.report.clearance"
                        :disabled="(loggedUser.role !== UserRoles.ADMIN && loggedUser.role !== UserRoles.REGIONAL_ADMIN) || !MonitoringForm.isEditable"
                        >
                        <label>{{ $t('monitoring.field_title_cleared') }}</label>
                    </radio>
                    <radio name="report.clearance"
                        class="form-check-inline"
                        value="not-cleared"
                        v-model="MonitoringForm.report.clearance"
                        :disabled="(loggedUser.role !== UserRoles.ADMIN && loggedUser.role !== UserRoles.REGIONAL_ADMIN) || !MonitoringForm.isEditable"
                        >
                        <label>{{ $t('monitoring.field_title_not_cleared') }}</label>
                    </radio>
                </div>
                <comment-box
                    class="form-group"
                    v-model="MonitoringForm.report.clearance_comments"
                    :is-editable="(loggedUser.role === UserRoles.ADMIN || loggedUser.role === UserRoles.REGIONAL_ADMIN) && MonitoringForm.isEditable"
                    :comments="MonitoringForm.report.clearance_comments"
                    :pull-right="false">
                </comment-box>
                <base-button
                    v-if="(loggedUser.role === UserRoles.ADMIN || loggedUser.role === UserRoles.REGIONAL_ADMIN) && MonitoringForm.isEditable"
                    type="primary"
                    class="validate-report pull-right mb-3 mr-3"
                    @click="validateReport"
                    >
                    Validate Report
                </base-button>
            </div>
        </div>

        <upload-file
            v-if="(loggedUser.role === UserRoles.ADMIN || loggedUser.role === UserRoles.REGIONAL_ADMIN) && MonitoringForm.report_type === 'financial'"
            v-model="MonitoringForm.files.financial['admin_report_' + reportId]"
            :section="'financial.admin_report_' + reportId"
            class="upload-report-box"
            :file-data="MonitoringForm.files.financial['admin_report_' + reportId]"
            :is-editable="MonitoringForm.isEditable"
            :model-name="'Monitoring'"
            :size-limit="MonitoringForm.fileSizeLimit"
            >
            <div class="row">
                <div class="col-lg-12 upload-report-inner-box">
                    <h4>{{ $t('monitoring.button_title__upload_financial_checklist') }}</h4>
                </div>
            </div>
        </upload-file>

        <div class="row mt-5" v-if="MonitoringForm.initialized && MonitoringForm.isEditable">
            <div class="col-12">
                <base-button type="default" wide @click.native="saveProgress">{{$t('general.save_progress')}}</base-button>
                <base-button class="pull-right" wide @click.native="submitt">{{$t('general.submit')}}</base-button>
            </div>
        </div>
    </div>
</template>
<script>
    import ComponentLoader from './ComponentLoader';
    import {MonitoringService, GrantService, UserRoles, FileUploadService, MonitoringForm} from '@/services';
    import {EventBus} from '@/event-bus.js';
    import {CommentBox} from 'src/components';

    export default
    {
        components:
        {
            ComponentLoader,
            CommentBox,
        },
        data()
        {
            return {
                UserRoles,
                MonitoringForm,
                grantId: parseInt(this.$route.params.grantId) || null,
                applicationId: parseInt(this.$route.params.applicationId) || null,
                reportId: parseInt(this.$route.params.reportId) || null,
                componentInitialized: false,
                componentName: 'Dynamic',
                defaultComponentName: 'Default',
            }
        },
        async beforeCreate()
        {
            const vm = this;
            const loader = vm.$loading.show();

            vm.loggedUser = vm.$store.getters['Auth/loggedUser'];

            const grantId = parseInt(vm.$route.params.grantId);
            const applicationId = parseInt(vm.$route.params.applicationId);
            const reportId = parseInt(vm.$route.params.reportId);
            const objectAssignDeep = require('object-assign-deep');

            MonitoringForm.init();

            MonitoringForm.reportId = reportId;
            MonitoringForm.grantId = grantId;
            MonitoringForm.applicationId = applicationId;

            await GrantService.get(grantId).then((response) =>
            {
                if (response.data.type === 'static')
                {
                    vm.componentName = response.data.componentName.replace('index', 'report');
                }

                MonitoringForm.model = {grant_agreement: {}, logical: {}, technical: {}, monthly: {}, financial: {}};
                MonitoringForm.files = {grant_agreement: {}, logical: {}, technical: {}, monthly: {}, financial: {}};

                vm.componentInitialized = true;
            });

            MonitoringForm.initialized = false;
            MonitoringForm.isEditable = false;

            await MonitoringService.getReport(reportId).then((response) =>
            {
                MonitoringForm.report = response.data.data;
                MonitoringForm.report_type = response.data.report_type;
                MonitoringForm.new_report=response.data.new_report!=null?response.data.new_report:false
                // MonitoringForm.report.status = response.data.locked ? 'LOCKED;

                // MonitoringForm.report.files = {...MonitoringForm.report.files, ...response.data.files};
                MonitoringForm.files = {...MonitoringForm.files, ...response.data.files};

                MonitoringForm.report.start_date = response.data.start_date;
                MonitoringForm.report.end_date = response.data.end_date;

                // setting filesize limit to state
                MonitoringForm.fileSizeLimit = response.data.upload_max_filesize;
                // max number of annexures
                MonitoringForm.max_annexure = response.data.max_annexure;

            });

            await MonitoringService.getAwardedApplication({
                grantId: grantId,
                applicationId: applicationId
            }).then((response) =>
            {
                MonitoringForm.model = objectAssignDeep(MonitoringForm.model, response.data.data);
                // MonitoringForm.files = {...MonitoringForm.files, ...response.data.files};

                MonitoringForm.title = response.data.title;
                MonitoringForm.organisation = response.data.organisation;
                MonitoringForm.reference = response.data.reference;

                MonitoringForm.initialized = true;

                if (vm.loggedUser.role !== UserRoles.AUDITOR)
                {
                    MonitoringForm.isEditable = !MonitoringForm.report.locked;
                }

            });

            loader.hide();
        },
        mounted()
        {
            const vm = this;

            // EventBus.$off('monitoring-save-progress');
            // EventBus.$on('monitoring-save-progress', data => { vm.saveProgress(); });

            // EventBus.$off('monitoring-submit');
            // EventBus.$on('monitoring-submit', data => { vm.submitt(); });
            EventBus.$off('monitoring-files-add');
            EventBus.$on('monitoring-files-add', data => { if (data instanceof File) vm.selectedFile(data); });
        },
        methods:
        {
            async saveProgress(status)
            {
                const vm = this;
                const loader = vm.$loading.show();

                await MonitoringService.updateReport({
                    reportId: MonitoringForm.reportId,
                    model: MonitoringForm.report,
                    status: status,
                    action_type:status,
                    period:this.$route.params.key
                }).then((response) =>
                {
                    if (status === 'lock')
                    {
                        MonitoringForm.isEditable = false;
                    }
                });

                await vm.uploadFiles();

                loader.hide();
            },

            async submitt()
            {
                this.saveProgress('submit');
            },

            async uploadFiles()
            {
                const vm = this;
                let files = MonitoringForm.files;
                let promises = [];
                let section;
                let sub_section;

                for (section in files)
                {
                    if (files.hasOwnProperty(section))
                    {
                        for (sub_section in files[section])
                        {
                            if (files[section].hasOwnProperty(sub_section))
                            {
                                let file_to_upload = files[section][sub_section];

                                if (file_to_upload instanceof File)
                                {
                                    let form_data = new FormData();

                                    form_data.append('file', file_to_upload);
                                    form_data.append('section', file_to_upload.section);
                                    form_data.append('$section', section);
                                    form_data.append('$sub_section', sub_section);

                                    if (file_to_upload.id)
                                    {
                                        form_data.append('id', file_to_upload.id);
                                    }

                                    let promise = FileUploadService.uploadMonitoringReportFiles({
                                        reportId: MonitoringForm.reportId,
                                        formData: form_data
                                    }).then((response) =>
                                    {
                                        const fd_section = form_data.get('$section');
                                        const fd_sub_section = form_data.get('$sub_section');

                                        MonitoringForm.files[fd_section][fd_sub_section] =
                                        {
                                            id: response.data.id,
                                            name: response.data.filename,
                                            download: response.data.download
                                        };
                                    }).catch((error) => console.log('error: ', error));

                                    promises.push(promise);
                                }
                            }
                        }
                    }
                }

                return await Promise.all(promises);
            },

            async validateReport()
            {
                MonitoringForm.report.locked = true;
                MonitoringForm.report.status = 'LOCKED';

                this.saveProgress('lock');
            },

            selectedFile(e) {
                this.saveProgress('save');
            }
        },
    };
</script>
